export const APPOINTMENT_ACTION = {
  UPDATE_APPOINTMENT_DETAIL: "appointment_action_update_appointment_detail"
};

export const DATASOURCE_ACTION = {
  UPDATE_DATASOURCE: "datasource_action_update_datasource",
  UPDATE_TIMESLOTS: "datasource_action_update_timeslots",
  LOCATION_POSITION_LOAD: "datasource_action_location_position_load",
  TOGGLE_TIMESLOTS_LOADING: "datasource_action_toggle_timeslots_loading"
};

export const BOOKING_ACTION = {
  GO_TO_STEP: "booking_action_go_to_step",
  GO_BACK_TO_STEP: "booking_action_go_back_to_step",
  COMPLETE_STEP: "booking_action_complete_step",
  TOGGLE_DRAWER: "booking_action_toggle_drawer",
  RELOAD_STEPS: "booking_action_reload_steps",
  START_LOADING: "booking_action_start_loading",
  FINISH_LOADING: "booking_action_finish_loading",
  GO_TO_PAGE: "booking_action_go_to_page",
  MAKE_NEW_BOOKING: "booking_action_make_new_booking"
};

export const PORTAL_ACTION = {
  CONFIG_LOAD_SUCCESS: "portal_action_config_load_success"
};

export const WAITING_LIST_ACTION = {
  REQUIRE_WAITING_LIST: "waiting_list_action_require_waiting_list",
  UPDATE_PREFERRED_TIME: "waiting_list_action_update_preferred_time"
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/types.js